import BulletPointsCard from '../BulletPointsCard'
import List from '../../Icons/coaching/list.svg'
import Target from '../../Icons/coaching/target.svg'
import Trusted from '../../Icons/coaching/trusted.svg'

const bulletPoints = [
    {
        title: 'Target Criteria Guidance',
        description:
            'Receive expert advice on selecting the right target criteria for your market, such as vacant properties, absentee owners, and more.',
        icon: Target,
    },
    {
        title: 'Trusted Data Recommendations',
        description:
            'Learn about the most reliable data providers for your region.',
        icon: Trusted,
    },
    {
        title: 'List Building',
        description:
            'Create premium and predictive lists to ensure you are targeting the highest potential contacts.',
        icon: List,
    },
]

function ListBuilding({ props }) {
    return (
        <BulletPointsCard
            {...props}
            title="Customized List Building"
            bulletPoints={bulletPoints}
            imagePath="/assets/coaching/2.png"
            mobileImagePath={'/assets/coaching/2-mobile.png'}
        />
    )
}

export default ListBuilding
